export default __webpack_public_path__ + "static/media/colors.fc0a0cd7.jpg";